import type { QueryParamConfig } from 'use-query-params';
import { encodeDelimitedArray, decodeDelimitedArray } from 'use-query-params';

export const CommaArrayParam: QueryParamConfig<string[] | null | undefined, (string | null)[] | null | undefined> = {
  encode: (array) => encodeDelimitedArray(array, ','),
  decode: (arrayStr) => decodeDelimitedArray(arrayStr, ','),
};
